import { Close } from '@mui/icons-material';
import { Box, ListItemText } from '@mui/material';
import { usePageManager } from 'hooks/pageManager/usePageManager';
import { useNavigate } from 'react-router-dom';

import {
  NavList,
  NavListItem,
  StyledListItemIcon,
  SubListItemActiveIcon,
} from '../MenuBar/NavLinksRenderer/NavLinksRenderer';

export const SidebarTabs = () => {
  const {
    pages,
    activeTabId,
    setActiveTabId,
    closeTabById,
    skipNextNavigation,
  } = usePageManager();

  const navigate = useNavigate();

  const closeTab = tab => e => {
    e.stopPropagation();
    closeTabById(tab.id);
  };

  return (
    <Box dir="rtl" sx={{ width: '100%' }}>
      <NavList>
        {pages?.map(tab => (
          <NavListItem
            key={tab.id}
            selected={tab.id === activeTabId}
            onClick={() => {
              skipNextNavigation.current = true;
              setActiveTabId(tab.id);
              navigate(tab.href);
            }}
          >
            {tab.id === activeTabId && (
              <StyledListItemIcon color="inherit">
                <SubListItemActiveIcon />
              </StyledListItemIcon>
            )}
            <ListItemText
              primary={tab.label}
              sx={{
                marginInline: '16px',
                ml: 'auto',
                textAlign: 'right',
              }}
            />
            <Close fontSize="small" onClick={closeTab(tab)} />
          </NavListItem>
        ))}
      </NavList>
    </Box>
  );
};
